import view from "../views/index";

const Remaining = () => {
  const remainingTime = document.querySelector("#remaining-time__time")?.dataset?.remainingTime
  const $label = document.querySelector("#TimeCounterLabel");
  const message = $label?.dataset?.message;
  if (remainingTime > 0) {
    if (message) {
      $label.innerHTML = message;
    }
    const SECOND = 1000,
      MINUTE = SECOND * 60,
      HOUR = MINUTE * 60,
      DAY = HOUR * 24;

    const calculateAndResolveReminder = (endDateTimestamp) => {
      if (isNaN(endDateTimestamp))
        document.querySelector("#remaining-time").remove();

      const populateRemainingTime = (initialTimestamp, finalTimestamp) => {
        const reminder = finalTimestamp - initialTimestamp,
          d = Math.floor(reminder / DAY),
          h = Math.floor((reminder % DAY) / HOUR),
          m = Math.floor((reminder % HOUR) / MINUTE),
          s = Math.floor((reminder % MINUTE) / SECOND);
        view("REMAINING_TIME", [d, h, m, s]);
      };

      setInterval(
        () => populateRemainingTime(new Date().getTime(), endDateTimestamp),
        SECOND
      );
    };

    calculateAndResolveReminder(remainingTime);
  } else {
    document.querySelector("#remaining-time").remove();
  }
};

export default Remaining;



// WEBPACK FOOTER //
// ./Statics/scripts/paywall/components/remaining.js